/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.Aks.SchadenTypAks
 * Art des Schaden beim Auslandskrankenschutz, Werte: None = 0; Krankheit = 1; Unfall = 2; Tod = 3; 
 */
export enum SchadenTypAksApi {
	None = 0,  // None
	Krankheit = 1,  // Krankheit
	Unfall = 2,  // Unfall
	Tod = 3  // Tod
};